/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import React from 'react';
// @ts-ignore
import Fade from 'react-reveal/Fade';

/**
 *
 * Scroll Fade In component
 * @extends {React.Component}
 */
class ScrollFadeIn extends React.Component {
  public render(): JSX.Element {
    return (
      <Fade bottom distance='1%' duration={1500}>
        {this.props.children}
      </Fade>
    );
  }
}

export default ScrollFadeIn;
